// =============================
// Imports
// =============================

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Flex, Icons, Tooltip } from '@mewo/components';

import Button from '../../../presentationals/button';
import { DropdownList } from '../../../presentationals/dropdown';
import { isHoverPrimary } from '../../../../helpers/front/getHoverType';

// =============================
// Styles
// =============================

export const Actions = styled(Flex)`
  align-items: center;

  > *:not(:last-child) {
    margin-right: 1.2rem;
  }
`;

const PlayPauseButtonBase = styled(Button).attrs({
  color: 'primary',
  fillVariant: 'plain',
  size: 'small',
})``;

const PlayButtonIcon = styled(Icons.ArrowSorting).attrs(({ theme }) => ({
  dir: 'east',
  fill: theme.colors.primaryText,
  width: '1rem',
}))`
  margin-right: 0.8rem;
`;

export const PlayButton = ({ children, ...rest }) => (
  <PlayPauseButtonBase {...rest}>
    <PlayButtonIcon />
    {children}
  </PlayPauseButtonBase>
);

PlayButton.propTypes = {
  children: PropTypes.node.isRequired,
};

const PauseButtonIcon = styled(Icons.Pause).attrs(({ theme }) => ({
  fill: theme.colors.primaryText,
  width: '0.7rem',
}))`
  margin-right: 0.8rem;
`;

export const PauseButton = ({ children, ...rest }) => (
  <PlayPauseButtonBase {...rest}>
    <PauseButtonIcon />
    {children}
  </PlayPauseButtonBase>
);

PauseButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export const AddToPlaylistIcon = styled(Icons.Plus).attrs(({ theme }) => ({
  fill: theme.colors.text,
  width: '2rem',
}))``;

export const DownloadIcon = styled(Icons.Download).attrs(({ theme }) => ({
  fill: theme.colors.text,
  width: '2rem',
}))``;

export const ThreeDotIcon = styled(Icons.ThreeDot).attrs(({ theme }) => ({
  fill: theme.colors.text,
  noButton: true,
  width: '2rem',
}))``;

export const ShareIcon = styled(Icons.Share).attrs(({ theme }) => ({
  fill: theme.colors.text,
  width: '2rem',
}))``;

export const DropdownButton = styled(DropdownList).attrs({
  width: '2rem',
})``;

export const StyledTooltip = styled(Tooltip).attrs({
  enterDelay: 300,
  interactive: true,
  placement: 'top-start',
})`
  ${({ theme }) => (isHoverPrimary(theme.colors)
    ? css`
      &:hover {
        svg path {
          fill: ${theme.colors.primary};
        }
      }
    `
    : css`
      &:hover {
        svg path {
          fill-opacity: 0.7;
        }
      }
    `)};

  & .tooltip {
    background-color: ${({ theme }) => theme.colors.text};
    color: ${({ theme }) => theme.colors.background};
    font-size: 1.2rem;
    line-height: 1.5rem;
    padding: 1rem;
  }
`;
